import React from "react";
import { Route, Redirect } from "react-router-dom";
import usePermissions from "../utils/permissions";

// Drop-in replacement for <Route> that actually enforces the page
// permission a URL corresponds to, instead of relying on NavBar.js hiding
// the sidebar link - a hidden link never stopped anyone who typed the URL
// directly. Pass `page` as one of the PERMISSION_PAGES names (see
// utils/permissionPages.js) to require canReadPage(page); pass
// `adminOnly` instead for a route with no per-page permission at all
// (e.g. user/role management), which only ever made sense for admins.
// Supports the same `component`/`render` API <Route> does, so swapping the
// tag name (plus adding `page`) is the only change existing routes need.
const PermissionRoute = ({ page, adminOnly = false, component: Component, render, ...routeProps }) => {
  const { isAdmin, canReadPage, loading } = usePermissions();

  return (
    <Route
      {...routeProps}
      render={(props) => {
        const renderInner = () => (Component ? <Component {...props} /> : render ? render(props) : null);

        // Fail-open while permissions are still loading (right after
        // login, before the one-time fetch resolves) - bouncing a
        // legitimate user to "/" for a flash before their real
        // permissions arrive reads as a broken link far more often than
        // it blocks anyone real: this route was already behind login.
        if (loading) return renderInner();

        const allowed = isAdmin() || (!adminOnly && canReadPage(page));
        if (!allowed) return <Redirect to="/PosMainScreen" />;

        return renderInner();
      }}
    />
  );
};

export default PermissionRoute;
